// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', -apple-system, BlinkMacSystemFont, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
}

code {
  font-family: 'Fira Code', 'JetBrains Mono', source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* Legal Theme Color Variables */
:root {
  --legal-primary: #1e3a8a;
  --legal-primary-light: #3b82f6;
  --legal-secondary: #b45309;
  --legal-accent: #d97706;
  --legal-success: #059669;
  --legal-warning: #d97706;
  --legal-error: #dc2626;
  --legal-text-primary: #1f2937;
  --legal-text-secondary: #6b7280;
  --legal-background: #ffffff;
  --legal-surface: #f8fafc;
  --legal-border: #e5e7eb;
  --legal-shadow: rgba(0, 0, 0, 0.1);
}

.message-container {
  max-width: 100%;
  overflow-wrap: break-word;
  position: relative;
}

.user-message {
  background: linear-gradient(135deg, var(--legal-primary) 0%, var(--legal-primary-light) 100%);
  color: white;
  border-radius: 20px 20px 4px 20px;
  padding: 14px 18px;
  margin: 8px 0;
  align-self: flex-end;
  max-width: 80%;
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.2);
  border: none;
  font-weight: 500;
}

.user-message .timestamp {
  color: rgba(255, 255, 255, 0.8);
}

.assistant-message {
  background: var(--legal-background);
  color: var(--legal-text-primary);
  border-radius: 20px 20px 20px 4px;
  padding: 14px 18px;
  margin: 8px 0;
  align-self: flex-start;
  max-width: 80%;
  box-shadow: 0 4px 12px var(--legal-shadow);
  border: 1px solid var(--legal-border);
}

.timestamp {
  font-size: 0.75rem;
  color: var(--legal-text-secondary);
  margin-top: 6px;
  font-weight: 400;
  opacity: 0.8;
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 200px);
  background: var(--legal-surface);
  border-radius: 12px;
  margin: 8px;
  box-shadow: 0 4px 24px var(--legal-shadow);
  overflow: hidden;
}

.message-list {
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px;
  background: var(--legal-surface);
}

.input-container {
  padding: 20px;
  border-top: 2px solid var(--legal-border);
  background: var(--legal-background);
}

.panel {
  padding: 24px 20px;
  height: calc(100vh - 64px);
  overflow-y: auto;
  background: var(--legal-background);
  border-right: 2px solid var(--legal-border);
}

.panel-title {
  margin-bottom: 24px !important;
  color: var(--legal-text-primary);
  font-weight: 700;
  font-size: 1.25rem;
  letter-spacing: -0.025em;
}

.document-item {
  margin-bottom: 12px;
  transition: all 0.2s ease;
}

.document-item:hover {
  transform: translateY(-1px);
}

/* Fade effect for long texts */
.fade-text {
  position: relative;
  max-height: 100px;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.fade-text::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), var(--legal-background));
}

.fade-text.expanded {
  max-height: none;
}

.fade-text.expanded::after {
  display: none;
}

/* Professional Card Styling */
.legal-card {
  background: var(--legal-background);
  border: 1px solid var(--legal-border);
  border-radius: 12px;
  box-shadow: 0 4px 16px var(--legal-shadow);
  transition: all 0.2s ease;
}

.legal-card:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

/* Professional Accordion Styling */
.legal-accordion {
  background: var(--legal-background);
  border: 1px solid var(--legal-border);
  border-radius: 12px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px var(--legal-shadow);
}

.legal-accordion-summary {
  background: linear-gradient(135deg, var(--legal-surface) 0%, #ffffff 100%);
  border-radius: 12px 12px 0 0;
  font-weight: 600;
  color: var(--legal-text-primary);
}

/* Professional Button Styling */
.legal-button-primary {
  background: linear-gradient(135deg, var(--legal-primary) 0%, var(--legal-primary-light) 100%);
  color: white;
  font-weight: 600;
  text-transform: none;
  border-radius: 8px;
  padding: 10px 20px;
  transition: all 0.2s ease;
}

.legal-button-primary:hover {
  background: linear-gradient(135deg, #1e40af 0%, #2563eb 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(30, 58, 138, 0.3);
}

.legal-button-secondary {
  background: transparent;
  color: var(--legal-primary);
  border: 2px solid var(--legal-primary);
  font-weight: 600;
  text-transform: none;
  border-radius: 8px;
  padding: 8px 18px;
  transition: all 0.2s ease;
}

.legal-button-secondary:hover {
  background: var(--legal-primary);
  color: white;
  transform: translateY(-1px);
}

/* Professional Input Styling */
.legal-input {
  background: var(--legal-background);
  border-radius: 8px;
}

.legal-input .MuiOutlinedInput-root {
  border-radius: 8px;
}

.legal-input .MuiOutlinedInput-notchedOutline {
  border-color: var(--legal-border);
  border-width: 2px;
}

.legal-input .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: var(--legal-primary);
}

.legal-input .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--legal-primary);
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--legal-surface);
}

::-webkit-scrollbar-thumb {
  background: var(--legal-border);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--legal-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,2GAA2G;EAC3G,mCAAmC;EACnC,kCAAkC;EAClC,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,8GAA8G;AAChH;;AAEA,gCAAgC;AAChC;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6FAA6F;EAC7F,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,6CAA6C;EAC7C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;EACX,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uFAAuF;AACzF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,0EAA0E;EAC1E,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,gCAAgC;AAChC;EACE,6FAA6F;EAC7F,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', -apple-system, BlinkMacSystemFont, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  min-height: 100vh;\n}\n\ncode {\n  font-family: 'Fira Code', 'JetBrains Mono', source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* Legal Theme Color Variables */\n:root {\n  --legal-primary: #1e3a8a;\n  --legal-primary-light: #3b82f6;\n  --legal-secondary: #b45309;\n  --legal-accent: #d97706;\n  --legal-success: #059669;\n  --legal-warning: #d97706;\n  --legal-error: #dc2626;\n  --legal-text-primary: #1f2937;\n  --legal-text-secondary: #6b7280;\n  --legal-background: #ffffff;\n  --legal-surface: #f8fafc;\n  --legal-border: #e5e7eb;\n  --legal-shadow: rgba(0, 0, 0, 0.1);\n}\n\n.message-container {\n  max-width: 100%;\n  overflow-wrap: break-word;\n  position: relative;\n}\n\n.user-message {\n  background: linear-gradient(135deg, var(--legal-primary) 0%, var(--legal-primary-light) 100%);\n  color: white;\n  border-radius: 20px 20px 4px 20px;\n  padding: 14px 18px;\n  margin: 8px 0;\n  align-self: flex-end;\n  max-width: 80%;\n  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.2);\n  border: none;\n  font-weight: 500;\n}\n\n.user-message .timestamp {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.assistant-message {\n  background: var(--legal-background);\n  color: var(--legal-text-primary);\n  border-radius: 20px 20px 20px 4px;\n  padding: 14px 18px;\n  margin: 8px 0;\n  align-self: flex-start;\n  max-width: 80%;\n  box-shadow: 0 4px 12px var(--legal-shadow);\n  border: 1px solid var(--legal-border);\n}\n\n.timestamp {\n  font-size: 0.75rem;\n  color: var(--legal-text-secondary);\n  margin-top: 6px;\n  font-weight: 400;\n  opacity: 0.8;\n}\n\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 200px);\n  background: var(--legal-surface);\n  border-radius: 12px;\n  margin: 8px;\n  box-shadow: 0 4px 24px var(--legal-shadow);\n  overflow: hidden;\n}\n\n.message-list {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding: 20px;\n  background: var(--legal-surface);\n}\n\n.input-container {\n  padding: 20px;\n  border-top: 2px solid var(--legal-border);\n  background: var(--legal-background);\n}\n\n.panel {\n  padding: 24px 20px;\n  height: calc(100vh - 64px);\n  overflow-y: auto;\n  background: var(--legal-background);\n  border-right: 2px solid var(--legal-border);\n}\n\n.panel-title {\n  margin-bottom: 24px !important;\n  color: var(--legal-text-primary);\n  font-weight: 700;\n  font-size: 1.25rem;\n  letter-spacing: -0.025em;\n}\n\n.document-item {\n  margin-bottom: 12px;\n  transition: all 0.2s ease;\n}\n\n.document-item:hover {\n  transform: translateY(-1px);\n}\n\n/* Fade effect for long texts */\n.fade-text {\n  position: relative;\n  max-height: 100px;\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n}\n\n.fade-text::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), var(--legal-background));\n}\n\n.fade-text.expanded {\n  max-height: none;\n}\n\n.fade-text.expanded::after {\n  display: none;\n}\n\n/* Professional Card Styling */\n.legal-card {\n  background: var(--legal-background);\n  border: 1px solid var(--legal-border);\n  border-radius: 12px;\n  box-shadow: 0 4px 16px var(--legal-shadow);\n  transition: all 0.2s ease;\n}\n\n.legal-card:hover {\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  transform: translateY(-2px);\n}\n\n/* Professional Accordion Styling */\n.legal-accordion {\n  background: var(--legal-background);\n  border: 1px solid var(--legal-border);\n  border-radius: 12px;\n  margin-bottom: 16px;\n  box-shadow: 0 2px 8px var(--legal-shadow);\n}\n\n.legal-accordion-summary {\n  background: linear-gradient(135deg, var(--legal-surface) 0%, #ffffff 100%);\n  border-radius: 12px 12px 0 0;\n  font-weight: 600;\n  color: var(--legal-text-primary);\n}\n\n/* Professional Button Styling */\n.legal-button-primary {\n  background: linear-gradient(135deg, var(--legal-primary) 0%, var(--legal-primary-light) 100%);\n  color: white;\n  font-weight: 600;\n  text-transform: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  transition: all 0.2s ease;\n}\n\n.legal-button-primary:hover {\n  background: linear-gradient(135deg, #1e40af 0%, #2563eb 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(30, 58, 138, 0.3);\n}\n\n.legal-button-secondary {\n  background: transparent;\n  color: var(--legal-primary);\n  border: 2px solid var(--legal-primary);\n  font-weight: 600;\n  text-transform: none;\n  border-radius: 8px;\n  padding: 8px 18px;\n  transition: all 0.2s ease;\n}\n\n.legal-button-secondary:hover {\n  background: var(--legal-primary);\n  color: white;\n  transform: translateY(-1px);\n}\n\n/* Professional Input Styling */\n.legal-input {\n  background: var(--legal-background);\n  border-radius: 8px;\n}\n\n.legal-input .MuiOutlinedInput-root {\n  border-radius: 8px;\n}\n\n.legal-input .MuiOutlinedInput-notchedOutline {\n  border-color: var(--legal-border);\n  border-width: 2px;\n}\n\n.legal-input .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: var(--legal-primary);\n}\n\n.legal-input .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: var(--legal-primary);\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--legal-surface);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--legal-border);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--legal-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
